import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import OfficeImg from "../assets/office2.png"
import { api } from '../app/Api/ApiSlice'
import { toast } from 'react-toastify'


const OrgBranchAdminCard = ({branch}) => {
    const [isLoading,setIsLoading] = useState()
    const navigate = useNavigate()
    const {organization} = useParams()

    const handleRemove = async()=>{
        try {
            setIsLoading(true)
            await api.post(`/${organization}/branches`,{branch:branch._id})
            setIsLoading(false)
            toast.success("Branch removed")
        } catch (error) {
            toast.error(error.response.data.message)
            setIsLoading(false)
        }
        finally{
            setIsLoading(false)
        }
    }

  return (
       <div className="added-branch-info">
            <img src={branch?.logo ? branch.logo : OfficeImg} alt="" />
            <div className="branch-desc">
                <h3 onClick={()=>navigate(`/${branch.name}`)}>{branch.name}</h3>
                <p>
                    {branch.description
                        ? branch.description.length > 50
                            ? `${branch.description.substring(0, 50)}...`
                            : branch.description
                        : "No description available"}
                </p>

                <button className="branch-action-card-btn" onClick={handleRemove}>{!isLoading?"Remove branch":"..."}</button>
            </div>
        </div>
  )
}

export default OrgBranchAdminCard